export default () => {
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const navMenu = document.querySelectorAll('[data-nav-menu]');
  const mnavHamburger = document.querySelector('[data-mnav-hamburger]');
  const mnav = document.querySelector('[data-mnav]');
  const mnavOverlayClose = document.querySelector('.mnav--mobile');
  const mnavClose = document.querySelectorAll('[data-mnav-close]');
  const mobileSubNav = document.querySelectorAll('[data-mnav-menu]');
  const mobileSubNavBack = document.querySelectorAll('[data-mnav-back]');
  const headerSection = document.querySelector('.header__section');
  //const stickyHeaderElement = document.querySelector('.stickyHeader');
  const bracketSections = document.querySelectorAll('.bracket-callout_content');
  let isScrolling = false;

  if (navMenu !== null) {
    navMenu.forEach((element) => {

      // DEV-HK: Disable this part for now
      /* document.addEventListener('scroll', () => {
        isScrolling = true;
        element.classList.remove('is-open');
        //element.querySelector('.navMegaMenu').classList.remove('delay-hover');

        const navMegaMenu = element.querySelector('.navMegaMenu');
        if (navMegaMenu && navMegaMenu.classList.contains('delay-hover')) {
            navMegaMenu.classList.remove('delay-hover');
        }
  
        clearTimeout(element.scrollTimeout);
        element.scrollTimeout = setTimeout(() => {
          isScrolling = false;
        }, 150);
      }); */
  
      element.addEventListener('mouseover', () => {
        if (!isScrolling) {
          if (!element.classList.contains('navMegaMenu')) {
            document.querySelector('.navMegaMenu').classList.remove('delay-hover');
          }
          element.classList.add('is-open');
          element.querySelector('.navMegaMenu').classList.add('delay-hover');
        }
      });
  
      element.addEventListener('mouseout', () => {
        element.classList.remove('is-open');
      });
    });
  }

  if (mnavHamburger !== null) {
    mnavHamburger.addEventListener('click', function (e) {
      e.preventDefault();
      mnav.classList.add('is-active');
      //html.classList.add('hidden');
      //body.classList.add('hidden');
      lockScroll();
    });
  }

  if (mnavClose !== null) {
    mnavClose.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        mnav.classList.remove('is-active');
        //html.classList.remove('hidden');
        //body.classList.remove('hidden');
        unlockScroll();
        mobileSubNav.forEach((item) => {
          item.nextElementSibling.classList.remove('is-open');
        });
      });
    });
  }

  if (mnavOverlayClose !== null) {
    mnavOverlayClose.addEventListener('click', function (e) {
      if (e.target === this) {
        e.preventDefault();
        this.classList.remove('is-active');
        //html.classList.remove('hidden');
        //body.classList.remove('hidden');
        unlockScroll();
        mobileSubNav.forEach((item) => {
          item.nextElementSibling.classList.remove('is-open');
        });
      }
    });
  } 
  
  if (mobileSubNav !== null) {
    mobileSubNav.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        item.nextElementSibling.classList.add('is-open');
      });
    });
  }

  if (mobileSubNavBack !== null) {
    mobileSubNavBack.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        item.closest('.mnavmenu__level1').classList.remove('is-open');
      });
    });
  }

  /*
    const stickyWatch = (entries) => {
    entries.forEach(entry => {
       headerSection.classList.toggle('header__section--sticky' , !entry.isIntersecting )
    });
  };

  const stickyWatchObserver = new IntersectionObserver(stickyWatch);
  stickyWatchObserver.observe(stickyHeaderElement);
  */

  headerSection.classList.toggle('header__section--top' , document.cookie.indexOf("announcement-bar=") < 0);
 
  const initNavTabs = () => {
    const tabWrappers = document.querySelectorAll(".tabs");
    tabWrappers.forEach((tabWrapper) => {
        const nav = tabWrapper.querySelector(".tabs__nav--js-tabs");
        if (!nav) return;

        const navLinks = nav.querySelectorAll(".tabs__link");
        const slideRect = nav.querySelector(".tabs__slider-rect");
        const tabContents = tabWrapper.querySelectorAll(".nav__child");
        const grandChildLists = tabWrapper.querySelectorAll(".nav__grandChild");

        nav.addEventListener("click", (evt) => {
            if (!evt.target.classList.contains("tabs__link")) {
                return;
            }
            evt.preventDefault();
            navLinks.forEach((item) => {
                item.classList.remove("tabs__link_active");
            });
            evt.target.classList.add("tabs__link_active");
            slideRect.style.transform = `translateX(${evt.target.dataset.transform}%)`;

            tabContents.forEach((content) => {
                content.classList.remove("nav__child_active");
            });
            grandChildLists.forEach((list) => {
                list.classList.remove("nav__grandChild_active");
            });

            const activeTabIndex = evt.target.dataset.tab;
            const activeContent = tabWrapper.querySelector(`.nav__child[data-tab-content="${activeTabIndex}"]`);
            const activeGrandChild = activeContent ? activeContent.querySelector(".nav__grandChild") : null;

            if (activeContent) {
                activeContent.classList.add("nav__child_active");
                if (activeGrandChild) {
                    activeGrandChild.classList.add("nav__grandChild_active");
                }
            }
        });
    });
  };

  initNavTabs();


  let ticking = false;

  function updateHeaderTop() {
    const rect = headerSection.getBoundingClientRect();
    const docTop = rect.top + window.pageYOffset;
    const isStuck = rect.top <= 1; // mała tolerancja (1px) na subpiksele

    const value = isStuck ? 0 : docTop;
    document.documentElement.style.setProperty('--header-top', `${value}px`);

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateHeaderTop);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestTick);
  window.addEventListener('resize', requestTick);

  updateHeaderTop();

  /*const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      entry.target.classList.toggle('active', entry.isIntersecting);
    });
  }, {
    threshold: 0.2
  });

  bracketSections.forEach((section, i) => {
    section.style.transitionDelay = `${i * 1.55}s`;
    observer.observe(section);
  });*/

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');

        setTimeout(() => {
          entry.target.style.transitionDelay = '0s, 0.12s';
        }, 50);
      }
    });
  }, {
    rootMargin: '-80px',
    threshold: 0
  });

  bracketSections.forEach(el => observer.observe(el));

  let scrollPosition = 0;

  function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    body.style.position = 'absolute';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.style.overflow = '';
    window.scrollTo(0, scrollPosition);
  }
}